import { axiosInstance,axiosRequestWithAuth } from './../constants/server.constant';

export const BackupService = {
    getScheduleList,
    createSchedule,
    cancelScheduleByid,
    editSchedule
};

function getUserId() {
    return localStorage.getItem('userId');
}

async function getScheduleList(instanceId) {
    return await axiosInstance.get('/backup/'+instanceId+'/instance/'+getUserId(),axiosRequestWithAuth)
        .then(resp => {
            let data = resp.data
            if(data === undefined) {
                return resp
            }
            return data
        }).catch(function (error) {
            return []
        });
}

async function createSchedule(requestBody) {
    return await axiosInstance.post('/backup/'+getUserId(), requestBody , axiosRequestWithAuth)
        .then(resp => {
            return resp.data;
        }).catch(function (error) {
            return false
        });
}

async function editSchedule(id) {
    return await axiosInstance.put('/backup/'+id+'/'+getUserId(), {} , axiosRequestWithAuth)
        .then(resp => {
            return resp.data;
        }).catch(function (error) {
            return false
        });
}

async function cancelScheduleByid(id) {
    return axiosInstance.delete('/backup/'+id+'/'+getUserId(), axiosRequestWithAuth)
        .then(resp => {
            return resp.data;
        }).catch(function (error) {
            return false;
        });
}

export default BackupService;